export const API_INSTANCE_DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export const ABORT_REASON_403_REINIT = 'Aborted due to 403 redirect'

export const pendingControllers = new Set<AbortController>()
